import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withApollo} from 'react-apollo';
import {autobind} from 'core-decorators';
import Select from 'react-select';
import {normalize} from 'core/utils';
import organizationsAutoCompleteQuery from 'graphql/queries/autocomplete-organizations.gql';
import localitiesAutoCompleteQuery from 'graphql/queries/autocomplete-localities.gql';
import salesUsersAutoCompleteQuery from 'graphql/queries/autocomplete-sales-users.gql';
import styles from './styles.less';
import classNames from 'classnames';

@withApollo
@autobind
export default class AutoCompleteSelect extends Component {
    static propTypes = {
        query: PropTypes.object.isRequired,
        value: PropTypes.any,
        placeholder: PropTypes.string,
        searchPrompt: PropTypes.string,
        disabled: PropTypes.bool,
        autoload: PropTypes.bool,
        variables: PropTypes.object,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        background: PropTypes.bool,
    };

    static defaultProps = {
        autoload: false,
        variables: {},
    };

    state = {
        value: undefined,
        searchCache: {},
        valueCache: {},
    };

    componentDidMount() {
        this.setValue({id: this.props.value});
    }

    componentWillReceiveProps(nextProps) {
        this.setValue({id: nextProps.value});
    }

    async setValue({id, label}) {
        if (!id) return this.setState({value: null});

        if (!this.state.valueCache[id]) {
            const option = {id, label};
            if (!label) {
                const response = await this.props.client.query({
                    query: this.props.query,
                    variables: {...this.props.variables, id},
                });
                option.label = response.data.options.length > 0 ? response.data.options[0].label : '';
            }
            this.setState({
                valueCache: {
                    ...this.state.valueCache,
                    [id]: option,
                },
            });
        }

        this.setState({value: this.state.valueCache[id]});
    }

    async loadOptions(query) {
        if (!query && !this.props.autoload) return {options: []};

        const response = await this.props.client.query({
            query: this.props.query,
            variables: {...this.props.variables, query: normalize(query)},
            fetchPolicy: 'no-cache',
        });

        if (response.errors) return {options: []};

        return {options: response.data.options};
    }

    filterOptions(options) { // noop
        return options;
    }

    onChange(option) {
        option = option || {};
        this.setValue(option);
        if (this.props.onChange) this.props.onChange(option.id, option);
    }

    renderIcon(icon) {
        return () => <i className='material-icons'>{icon}</i>;
    }

    render() {
        return (
            <div className={classNames(styles.root, {[styles.background]: this.props.background})}>
                <Select.Async
                    value={this.state.value}
                    valueKey='id'
                    labelKey='label'
                    autoload={this.props.autoload}
                    cache={this.state.searchCache}
                    loadOptions={this.loadOptions}
                    filterOptions={this.filterOptions}
                    onChange={this.onChange}
                    onBlur={this.props.onBlur}
                    disabled={this.props.disabled}
                    arrowRenderer={this.renderIcon('keyboard_arrow_down')}
                    clearRenderer={this.renderIcon('clear')}
                    clearable={this.props.clearable}
                    backspaceRemoves={this.props.clearable}
                    loadingPlaceholder='Cargando...'
                    placeholder={this.props.placeholder}
                    searchPromptText={this.props.searchPrompt}
                    noResultsText='No hay resultados.'
                />
            </div>
        );
    }
}

export const LocalitySelect = props => (
    <AutoCompleteSelect
        query={localitiesAutoCompleteQuery}
        placeholder='Localidad'
        searchPrompt='Escribí el nombre de la localidad'
        {...props}
    />
);

export const OrganizationSelect = props => (
    <AutoCompleteSelect
        query={organizationsAutoCompleteQuery}
        placeholder='Organización'
        searchPrompt='Escribí el nombre de la organización'
        autoload
        {...props}
    />
);

export const SalesUserSelect = props => (
    <AutoCompleteSelect
        query={salesUsersAutoCompleteQuery}
        placeholder='Comercial'
        searchPrompt='Escribí el nombre del comercial'
        autoload
        {...props}
    />
);



// WEBPACK FOOTER //
// ./components/forms/auto-complete-select/index.js